var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS2IconCheckmark = function SvgS2IconCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s2_icon_checkmark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.668 9.074a.958.958 0 0 1-.737-.345L.754 6.116a.96.96 0 1 1 1.474-1.228l1.418 1.701 4.112-5.233a.96.96 0 1 1 1.51 1.186L4.423 8.706a.958.958 0 0 1-.74.367h-.015Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "s2_icon_checkmark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h10v10H0z"
  })))));
};
export default SvgS2IconCheckmark;